import { useEffect } from "react";
import { IntlProvider } from "react-intl";
import enMessages from "../../../i18n/en.json";
import { useAuth } from "../../../routes/AuthProvider";
import { AboutUsListing } from "./AboutUsListing";
import { ContactUsListing } from "./ContactUsListing";
import { FaqListing } from "./FaqListing";
import { HomeListing } from "./HomeListing";
import Navbar from "./Navbar";

export const LandingPage = () => {
  const { logout } = useAuth();

  useEffect(() => {
    logout();
  }, []);

  return (
    <IntlProvider locale="en" messages={enMessages}>
      <div className="text-[#6e5f49]">
        <Navbar />
        <HomeListing />
        <AboutUsListing />
        <FaqListing />
        <ContactUsListing />
      </div>
    </IntlProvider>
  );
};
